import { ReviewerData } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const upsertCountryNominationReviewer: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  reviewerData: ReviewerData,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, countryId, nominationId, reviewerData, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/reviewer`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(reviewerData),
  },
).then((response) => responseErrorHandler<void>(
  fetchContext.errorStore,
  response,
  'upsert country nomination reviewer',
));
